<div class="modal-dialog modal-sm modal-warning" role="document">
    <form class="times-log-form">
      <div class="padding_left_css_right_time_long">
        <div class="col-sm-12 p-0">
          <div class="modal-content modal-content_data_fliter border_radies_filter_popup">
            <div class="wraningpopup_css border_radies_filter_popup_new">
              <div class="col-sm-12">
                <div class="d-flex justify-content-start">
                  <div>
                    <span><img src="../../../assets/img/addclient/warningIcon.svg" width="21" height="21" /></span>
                  </div>
                  <div class="ml-2">
                    <span class="warning_text_css kc-modal-title">Warning</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12  mt-3 mb-2">
              <div class="new_font_waring_css kc-form-label">
                {{warnmsgcontact}}
              </div>
              <div class="new_font_waring_css kc-form-label" *ngIf="_flagForline2">
                {{warnAlertmsgcontact}}
              </div>
            </div>
            <div class="bottom_Line_new_line"></div>
            <div class="mb-2 mt-2">
              <div class="col-sm-12 pt-1">
                <div class="d-flex justify-content-between">
                  <div class="">
                  </div>

                  <div class="">
                    <button type="submit" class="btn btn-primary KC_button_profile_css mr-2" (click)="closeno()">No</button>
                    <a class="KC_button_hover_client_profile_css" data-dismiss="modal" (click)="closeyes()">Yes</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>

